<template>
  <footer :class="{ 'brdr-top-1 brdr-cl-secondary': isCheckoutPage }">
    <additional-footer />
    <div class="copyright p10 align-center" style="color: #424242;">{{ getYear }} {{$t('All rights reserved')}}</div>
    <no-ssr>
      <back-to-top :bottom="isSafari ? '70px' : '20px'" right="20px" visibleoffset="200">
        <button type="button" class="btn-top button no-outline brdr-none cl-white bg-cl-mine-shaft :bg-cl-th-secondary py10 px10">
          <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
            <path d="M23.245 20l-11.245-14.374-11.219 14.374-.781-.619 12-15.381 12 15.391-.755.609z" fill="white" />
          </svg>
        </button>
      </back-to-top>
    </no-ssr>
  </footer>
</template>

<script async>
import { mapGetters } from 'vuex'
import CurrentPage from 'theme/mixins/currentPage'
import NoSSR from 'vue-no-ssr'
import { isServer, timezoneTime } from '@vue-storefront/core/helpers'

const BackToTop = () => import(/* webpackChunkName: "vsf-back-to-top" */ 'theme/components/core/BackToTop');
const AdditionalFooter = () => import(/* webpackChunkName: "vsf-additional-footer" */ './AdditionalFooter');

export default {
  mixins: [CurrentPage],
  name: 'MainFooter',
  methods: {
    goToAccount () {
      this.$bus.$emit('modal-toggle', 'modal-signup')
    }
  },
  computed: {
    ...mapGetters({
      isLogged: 'user/isLoggedIn'
    }),
    isSafari () {
      if (!isServer) {
        return /iphone/i.test(navigator.userAgent.toLowerCase()) && /safari/i.test(navigator.userAgent.toLowerCase()) && !/crios/i.test(navigator.userAgent.toLowerCase())
      }
    },
    getYear () {
      return timezoneTime().getFullYear()
    }
  },
  components: {
    AdditionalFooter,
    BackToTop,
    'no-ssr': NoSSR
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-secondary: color(secondary);

.copyright {
  background: white;
}

.icon {
  transition: 0.3s all;
}

.social-icon {
  width: 40px;
  height: 40px;
  &:hover,
  &:focus,
  &:active {
    .icon {
      fill: $color-secondary;
    }
  }
}
.links {
  list-style-type: none;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;

  @media (min-width: 769px) {
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
}

.bottom-links {
  @media (max-width: 768px) {
    padding: 0;
  }
}

.footer__version-info {
  display: flex;
  color: $color-secondary;
  font-size: 0.7rem;
  @media (min-width: 769px) {
    margin-right: 1rem;
    font-size: 0.8rem;
  }
}

.underline {
  &:hover {
    color: $color-secondary;
    &:after {
      background-color: $color-secondary;
    }
  }
}
.legal-entity-link {
  text-align: center;
  @media (min-width: 769px) {
    display: none;
  }
}

.privacy-policy-link {
  text-align: right;
  @media (min-width: 769px) {
    display: none;
  }
}

@media (max-width: 595px) {
  .no-mobile {
    display: none;
  }

  .social {
    margin-top: 0;
  }

  .footer-links {
    padding-bottom: 30px;
  }
}
</style>
